import { useEffect, useState } from 'react';

const STORAGE_KEY = 'rmaPdfLocale';
const DEFAULT_LOCALE = 'en';

export default function useRmaPdfLocale(initialLocale = DEFAULT_LOCALE) {
  const [locale, setLocale] = useState(() => {
    if (typeof window === 'undefined') {
      return initialLocale;
    }
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored || initialLocale;
    } catch (err) {
      return initialLocale;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch (err) {
      // ignore persistence failures
    }
  }, [locale]);

  return [locale, setLocale];
}
